/**
 * Single source of truth for platform_id across all API calls.
 * Override via REACT_APP_PLATFORM_ID in .env-cmdrc.json if needed.
 */
export const PLATFORM_ID = process.env.REACT_APP_PLATFORM_ID || 'abode';

/** Chat API only — backend expects a separate platform id for chat. */
export const CHAT_PLATFORM_ID = 'abode_labs';

export default PLATFORM_ID;
